export default {
  notification: {
    success: {
      token: 'New access code generated successfully.',
      enableSharing: 'Dashboard sharing enabled successfully.',
    },
  },
  label: {
    title: {
      published: 'Sharing',
      publishedBy: 'Published by:',
      publishedAt: 'Published at:',
      token: 'Access code',
      hiddenComponents: 'Hidden components',
      description: {
        token: 'When you generate a new code, users who access this dashboard with the current code will lose access.',
        dashboardHidden: 'This dashboard contains components with sensitive information that should not be accessible to guest users. If you proceed with sharing, those components will be automatically hidden. For more details, visit our',
        dashboardHiddenCentralLink: 'Help Center',
        dashboardHiddenAux: ' and consult our',
        dashboardHiddenPolicyLink: ' Sharing Policy.',
      },
    },
    panel: {
      components: 'Components',
    },
    tooltip: {
      notPermitted: 'You must be logged in to change sharing options.',
      notPublished: 'Dashboard not published. Publishing it will make it visible to anyone.',
      published: 'Dashboard published.',
      publishedBy: 'Published by:',
    },
    pagination: 'Showing {page} - {size} of {count}',
    switch: 'Shared dashboard',
    url: 'Access URL',
    token: 'Access code',
    button: {
      regenerateToken: 'Generate new access code',
      remove: 'Remove components',
    },
  },
};
